import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';
import { StarsRateComponent } from '@shared/components/stars-rate/stars-rate.component';
import { ExtractGrade } from '@shared/pipes/extractStarFromClassName.pipe';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'iho-residences-card',
  templateUrl: './residences-card.component.html',
  styleUrls: ['./residences-card.component.scss'],
  standalone: true,
  imports: [CommonModule, ExtractGrade, SharedModule, StarsRateComponent],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResidencesCardComponent {
  // cdr = inject(ChangeDetectorRef);
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  @Input({ required: true }) dataSource: any;

  router = inject(Router);

  goToPlp(e: Event) {
    e.preventDefault();
    if (isPlatformBrowser(this.platformId)) {
      this.router.navigate([this.dataSource.Url]);
    }
  }
  setParamsUrl(url: string) {
    this.router.navigate([url]);
  }

  goToHotel(e: Event, hotelUrl: string) {
    e.preventDefault();
    if (isPlatformBrowser(this.platformId)) {
      this.router.navigate([hotelUrl], { queryParams: { refer: 'home' } }).finally(() => {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 300);
      });
    }
  }
}
